import Cookie from '@nuxt-common/util/app/utils/cookie/Cookie.js';

import $http from '@nuxt-common/util/app/utils/http';

function redirect(url) {
  window.location.href = url;
}

function relativeRedirect(relativePath) {
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split(currentUrl);
  redirect(urlParts[0] + relativePath + urlParts[1]);
}

export function handleSignOut() {
  const domain = Cookie.getHostName();
  Cookie.remove('SignedIn', null, {
    domain,
  });
  Cookie.set('SE', 1, 'SNSGCs', {
    domain,
  });
  Cookie.set('FORWARDPAGE_KEY', window.location.href, null, {
    domain,
  });
  relativeRedirect('/account/signin');
}

export default function () {
  $http.interceptors.response.use(null, (error) => {
    const { status } = error?.response || {};

    if (status === 401) {
      handleSignOut();
    }
    return Promise.reject(error);
  });
}
